import { render, staticRenderFns } from "./user-group-token-editor.vue?vue&type=template&id=0361580a&scoped=true&"
import script from "./user-group-token-editor.vue?vue&type=script&lang=ts&"
export * from "./user-group-token-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-group-token-editor.vue?vue&type=style&index=0&id=0361580a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361580a",
  null
  
)

export default component.exports